<template>
	<div class="com-mod-section-container">
		<h3 class="com-mod-section-header">
			Resources
		</h3>
		<div class="clearfix">
			<div class="col-md-12 flush-left">
				<div class="resources-container">
					<div class="row">
						<div class="col-md-6">
							<div class="sub-container">
								<h3 class="module-title">
									{{ literatureHeader }}
								</h3>
								<ul>
									<li v-for="report in reports" :key="report.id"
										:class="{ 'divider-line-top': report.Label == 'Semi-Annual Report', 'divider-line-bottom': report.Label == 'Average Annual Total Returns' }">
										<a v-if="report.HasModal" :href="report.URL" :data-lid-id="report.LitID"
											data-behavior="modal" :data-target="report.ModalId" target="_blank">
											{{ report.Label }}
										</a>
										<a v-else :href="`${report.URL}`" target="_blank"> {{ report.Label }} </a>
										<span v-if="flagPDFURL(report.URL)" class="pdf"> (PDF) </span>
										<span v-if="report.LiteratureDate !== null && report.LiteratureDate !== '--'">
											{{
												report.LiteratureDate }} </span>
									</li>
								</ul>
							</div>
						</div>
						<div class="col-md-6">
							<div class="sub-container">
								<h3 class="module-title">
									{{ fundResourceHeader }}
								</h3>
								<ul>
									<li v-for="aboutOurFund in aboutOurFunds" :key="aboutOurFund.id">
										<span v-if="!flagPDF(aboutOurFund.URL)" class="arrow-wrapper">
											<i class="link-arrow" />
										</span>
										<a v-if="aboutOurFund.HasModal" :href="aboutOurFund.URL"
											:data-lid-id="aboutOurFund.LitID" data-behavior="modal"
											:data-target="aboutOurFund.ModalId" target="_blank">
											{{ report.Label }}
										</a>
										<a v-else :href="`${aboutOurFund.URL}`" target="_blank">{{ aboutOurFund.Label
											}}</a>
										<span v-if="flagPDF(aboutOurFund.ContentType)" class="pdf"> (PDF) </span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'ResourcesSection',
	computed: {
		...mapGetters([
			'getAboutOurFunds',
			'getReports',
			'getFundAttributes',
			'getAudience'
		]),
		headers() {
			return this.setHeaders(this.getAudience, this.getFundAttributes);
		},
		literatureHeader() {
			return this.headers && this.headers.literatureHeader || '--';
		},
		fundResourceHeader() {
			return this.headers && this.headers.fundResourceHeader || '--';
		},
		aboutOurFunds() {
			return this.getAboutOurFunds ? this.formatLiterature(this.getAboutOurFunds) : [];
		},
		reports() {
			return this.getReports ? this.formatLiterature(this.getReports) : [];
		}
	},
	methods: {
		flagPDF(contentType) {
			return contentType.length && contentType.slice(-3).toLowerCase() === 'pdf';
		},
		flagPDFURL(URL) {
			return URL.length && !URL.includes('https://capitalgroup.prospectus-express.com') && URL.toLowerCase().includes('pdf');
		},
		formatDate(date) {
			let result = date;
			//prevents reformatting to incorrect values when widgetData gets recomputed
			if (date && Number.isInteger(date)) {
				date = date.toString();
				if (date.length === 4) {
					const year = date.substring(0, 2);
					const month = date.substring(2, 4);
					result = `${month}/${year}`;
				}
			} else if (!date) {
				result = '--';
			}
			return result;
		},
		formatLiterature(arrayOfLiteratures) {
			let result = null;
			if (arrayOfLiteratures) {
				result = arrayOfLiteratures.map(item => {
					return Object.assign(item, {
						LiteratureDate: this.formatDate(item.LiteratureDate)
					});
				});
			}
			return result;
		},
		setHeaders(audience, getFundAttributes) {
			const fundSymbol = getFundAttributes && getFundAttributes.FundSymbol || '--';
			let literatureHeader = `Literature for ${fundSymbol}`;
			let fundResourceHeader = 'About Our Funds';
			if (audience && audience.toLowerCase() === 'individual') {
				literatureHeader = `Prospectuses & Reports for ${fundSymbol}`;
				fundResourceHeader = `About Our Funds`;
			} else if (audience && audience.toLowerCase() === 'institutional') {
				literatureHeader = `Literature`;
				fundResourceHeader = `Learn More`;
			}
			return { literatureHeader, fundResourceHeader };
		}
	}
};
</script>
<style lang='less'>
@import '~_css_/variables';

.resources-container {
	color: @dark-gray;
	font-family: @avenir-regular;

	.sub-container {
		border-top: 1px solid @light-gray;
	}

	ul {
		list-style-type: none;
		padding-left: 0;
		margin: 0;

		li {
			padding-bottom: 5px;
			padding-top: 5px;
			display: flex;

			.arrow-wrapper {
				display: inline-block;
				overflow: hidden;
			}

			.pdf {
				margin: 0 5px;
			}

			a {
				font-family: @avenir-demi-sans;
			}

			&.divider-line-top {
				border-top: 1px solid #ccc;
			}

			&.divider-line-bottom {
				border-bottom: 1px solid #ccc;
			}
		}
	}

	@media (max-width: 769px) {
		.row {
			div:nth-child(2) {
				margin: 40px 0 0 0px;
				padding: 0;
			}
		}
	}
}
</style>
